<ng-container *ngIf="noBaselineDefinitions">
    <div data-automation = "empty-page" class="empty-page">
        <mat-icon>warning</mat-icon>
        <h2>{{ 'baseline.list.none_configured' | translate }}</h2>
    </div>
</ng-container>
